import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetDeviceTreeCommand } from "@/model/communication/device/GetDeviceTreeCommand";
import { GetDeviceTreeReqData } from "@/model/communication/device/GetDeviceTreeReqData";
import { RootState } from "@/store";
import { ActionTree } from "vuex";
import { SET_DEVICE_TREE_CONTENT } from "./mutations";
import { DevicesState } from "./state";

export const FETCH_DEVICE_TREE = "FETCH_DEVICE_TREE";
export const FETCH_ALL_DEVICE_TREE = "FETCH_ALL_DEVICE_TREE";
export const GET_TOTAL_DEVICES = "GET_TOTAL_DEVICES";

export default {
    async [FETCH_DEVICE_TREE]({ commit }, node) {
        let request = new GetDeviceTreeReqData(node, false);
        const res = await new GetDeviceTreeCommand(request).execute();
        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            let content = res.deviceTree;
            commit(SET_DEVICE_TREE_CONTENT, { node, content });
        }
    },

    //Fetch dell'intero albero
    async [FETCH_ALL_DEVICE_TREE]({ commit }) {
        try {
            console.time(FETCH_ALL_DEVICE_TREE);
            let node = null;
            let request = new GetDeviceTreeReqData(node, true);
            const res = await new GetDeviceTreeCommand(request).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                let content = res.deviceTree;
                commit(SET_DEVICE_TREE_CONTENT, { node, content });
            }
            console.timeEnd(FETCH_ALL_DEVICE_TREE);
        } catch (error) {
            console.error("error in FETCH_ALL_DEVICE_TREE, exc: ", error);
        }
    },
} as ActionTree<DevicesState, RootState>;
